import React, { useState, useEffect } from "react";

function FullPageBackground(props) {
    return (
        <div className="bg-black-color full-page-background">
        </div>
    )
}

export default FullPageBackground